import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { fetchMarques } from "../../../store/actions/autreActions"
import { COLORS } from "../../../utilities/Constants"
import { generalStyles as gs } from "../../styles/styles"
import { tableStyles } from "../../styles/tableStyles"
import Loader from "../../basics/Loader"
import MarqueModeleModalV2 from "./MarqueModeleModalV2"

const styles = {
	header: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		marginBottom: 16,
	},
	title: { fontSize: 15, fontWeight: 600, color: COLORS.text },
	count: { fontSize: 13, color: COLORS.textLight },
	empty: {
		...tableStyles.empty,
		padding: "40px 16px",
		color: COLORS.textLight,
		fontSize: 14,
	},
	chip: {
		display: "inline-flex",
		alignItems: "center",
		padding: "2px 9px",
		borderRadius: 99,
		fontSize: 11,
		fontWeight: 500,
		color: COLORS.accent,
		backgroundColor: COLORS.accentLight,
	},
}

const MarqueRow = ({ marque, index, onOpen }) => {
	const [hover, setHover] = useState(false)
	const bg = hover ? tableStyles.rowHover : tableStyles.rowBg(index)
	return (
		<tr
			onDoubleClick={() => onOpen(marque)}
			onMouseEnter={() => setHover(true)}
			onMouseLeave={() => setHover(false)}
			style={{
				backgroundColor: bg,
				cursor: "pointer",
				transition: "background-color 0.12s",
			}}
		>
			<td style={{ ...tableStyles.td, fontWeight: 500 }}>
				{marque.nom || "—"}
			</td>
			<td style={tableStyles.td}>
				<span style={styles.chip}>{marque.nb_modeles ?? 0}</span>
			</td>
		</tr>
	)
}

// Onglet "Marques / modèles" de la Configuration : table des marques
// (nom + nb de modèles) + édition maître-détail par modal.
const MarquesV2 = () => {
	const dispatch = useDispatch()
	const marques = useSelector((s) => s.autreInfo.marques)
	const fetchState = useSelector((s) => s.autreInfo.fetchMarques)
	const [editing, setEditing] = useState(null) // marque | null

	useEffect(() => {
		dispatch(fetchMarques())
	}, [dispatch])

	const sorted = [...(marques || [])].sort((a, b) =>
		(a.nom || "").localeCompare(b.nom || "", "fr"),
	)
	const loading = fetchState.loading && sorted.length === 0

	return (
		<>
			{editing && (
				<MarqueModeleModalV2
					marque={editing}
					onClose={() => setEditing(null)}
				/>
			)}
			<div style={styles.header}>
				<div style={{ display: "flex", alignItems: "baseline", gap: 10 }}>
					<span style={styles.title}>Marques / modèles</span>
					<span style={styles.count}>{sorted.length}</span>
				</div>
				<button style={gs.btnPrimary} onClick={() => setEditing({})}>
					+ Nouvelle marque
				</button>
			</div>
			<div style={tableStyles.container}>
				{loading ? (
					<Loader variant="ring" message="Chargement…" />
				) : sorted.length === 0 ? (
					<div style={styles.empty}>Aucune marque.</div>
				) : (
					<table style={tableStyles.table}>
						<thead>
							<tr>
								<th style={tableStyles.th}>Nom</th>
								<th style={tableStyles.th}>Modèles</th>
							</tr>
						</thead>
						<tbody>
							{sorted.map((marque, index) => (
								<MarqueRow
									key={marque.id}
									marque={marque}
									index={index}
									onOpen={setEditing}
								/>
							))}
						</tbody>
					</table>
				)}
			</div>
		</>
	)
}

export default MarquesV2
